import React from 'react';
import { useHVAConversation } from './HVAProductAndOrdersContext';
import { Card } from 'react-bootstrap';

// Definimos el tipo para las categorías disponibles
type ProductCategory = 'Fontanería' | 'Pintura' | 'Ferretería' | 'Electricidad';

// Definimos el tipo para el mapeo de colores
type CategoryColors = {
  [K in ProductCategory]: string;
};

const ProductsList = () => {
  const { products } = useHVAConversation();

  // Definimos un mapeo de categorías a colores
  const categoryColors: CategoryColors = {
    Fontanería: 'bg-success text-white',
    Pintura: 'bg-primary text-white',
    Ferretería: 'bg-info text-white',
    Electricidad: 'bg-warning text-white'
  };

  // Función auxiliar para obtener el color de la categoría
  const getCategoryColor = (category: ProductCategory): string => {
    return categoryColors[category] || 'bg-gray-600 text-white';
  };

  if (products.length === 0) {
    return (
      <div className="mt-42">
        <h5 className="mb-1">Product catalog</h5>
        <Card className="border shadow-sm">
          <Card.Body className="p-3 text-center text-primary fs-10">
            No hay productos disponibles
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div className="mt-3">
      <h5 className="mb-1">Product catalog</h5>
      {/* Contenedor con altura máxima y scroll */}
      <div
        className="pt-0 mb-2 d-flex scrollbar flexcolumn justify-content-between"
        style={{
          height: '70px',
          overflowY: 'auto',
          scrollBehavior: 'smooth'
        }}
      >
        {products.map(product => (
          <div key={product.id}>
            <div
              className="border mb-1 me-1 bg-body-emphasis"
              style={{
                width: '262px',
                height: '60px'
              }}
            >
              {/* Encabezado con color según categoría */}
              <div
                className={`d-flex flexcolumn justify-content-between align-items-end ${getCategoryColor(
                  product.categoria as ProductCategory
                )} px-2 py-0`}
              >
                <div className="fs-10 fw-bold">ID: {product.id}</div>
                <div className="fs-9 fw-bold justify-content-end">
                  {product.precio.toFixed(2)}€
                </div>
              </div>
              {/* Contenido del producto */}
              <div className="p-2 pt-1 pb-0">
                <div className="d-flex flexcolumn justify-content-between align-items-center">
                  <div className="fs-10 fw-bold">{product.nombre}</div>
                  <div
                    className={`fs-10 fw-bold ${
                      product.stock > 0 ? 'text-success' : 'text-danger'
                    }`}
                  >
                    Stock: {product.stock}
                  </div>
                </div>
                <div className="fs-10 text-secondary lh-1">
                  {product.descripcion}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsList;
